module.exports = __webpack_public_path__ + "static/media/olake-benchmark-2.26c2f571.svg";